import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As of July 23rd, 2026, all new release documentation will be published alongside their respective release packages through our `}<a parentName="p" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`support portal`}</a>{` `}</p>
    <p>{`In addition to new releases, Cúram 8.2.2.0 (released July 3rd, 2026) and Cúram Action View 1.0.0 (released June 25th, 2026) documentation will also be available via our support portal for download.`}</p>
    <h3>{`For any other documentation referenced on this page, please contact `}<a parentName="h3" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`Merative Support`}</a></h3>
    <p>{`Cúram Action View 1.1.0 is now available. It provides caseworkers with a clear, person‑centred view, bringing together key information about an individual alongside the actions they need to take. By surfacing the most relevant details in one place, it helps caseworkers focus on what matters most and deliver services more efficiently.`}</p>
    <p>{`For more details about these features, see the following resources:`}</p>
    <ul>
      <li parentName="ul">{`Cúram Action View 1.1.0 release notes`}</li>
      <li parentName="ul">{`Cúram Action View Guide 1.1.0`}</li>
      <li parentName="ul">{`Cúram Action View Implementation Guide 1.1.0`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      